<template>
  <div id="search-page">
    <search-page-header />
    <capital-filter v-if="show" />
    <topic-filter v-if="show" />
    <sort-options v-if="show" @click="sortTopics"/>
    <div v-if="show">
      <div
        id="repos-placeholder"
        v-if="repos.length === 0"
      >
        <span>No Results Found</span>
      </div>
      <div id="repos">
        <RepoCard
          v-for="repo in repos"
          :key="repo"
          :repoName="repo"
        />
      </div>
    </div>
    <sui-segment v-else-if="error.length === 0" id="loader-container">
      <sui-dimmer active inverted id="loading-dimmer">
        <sui-loader content="Loading..." id="loader" size="large"/>
      </sui-dimmer>
    </sui-segment>
    <div v-else id="error-container">
      <span id="error">{{error}}</span>
    </div>
  </div>
</template>

<script>
import SearchPageHeader from '../components/SearchPageHeader';
import CapitalFilter from '../components/CapitalFilter';
import TopicFilter from '../components/TopicFilter';
import RepoCard from '../components/RepoCard';
import SortOptions from '../components/SortOptions';

import { mapActions } from 'vuex';

export default {
  data () {
    return {
      topics: [],
      sortOption: ''
    }
  },
  components: {
    SearchPageHeader,
    CapitalFilter,
    TopicFilter,
    RepoCard,
    SortOptions
  },
  computed: {
    repos() {
      const repos = this.$store.getters.getRepos;
      if (this.sortOption.length === 0) {
        return repos;
      } else {
        return repos.sort((a, b) => {
          return this.$store.getters.getRepo(b)[this.sortOption] - this.$store.getters.getRepo(a)[this.sortOption];
        });
      }
    },
    error() {
      return this.$store.state.loadingError;
    },
    show() {
      return this.$store.state.loaded && this.error.length === 0;
    },
    query() {
      return this.$route.query;
    }
  },
  methods: {
    ...mapActions([
      'updateOwner',
      'updateLoaded'
    ]),
    sortTopics(option) {
      switch (option) {
        case 'star': {
          this.sortOption = 'starCount';
          break;
        }
        case 'fork': {
          this.sortOption = 'forkCount';
          break;
        }
        case 'default': berak;
      }
    }
  },
  async created() {
    // this.$store.dispatch('updateLoaded', false);
    // await this.updateOwner({owner: 'yahoo', ownerType: 'org'});
    // this.$store.dispatch('updateLoaded' , true);

    if (this.query['owner-type'] !== undefined && this.query['owner'] !== undefined) {
      this.$store.dispatch('updateLoadingError', '');
      this.$store.dispatch('updateLoaded', false);
      try {
        await this.$store.dispatch('updateOwner', {owner: this.query.owner, ownerType: this.query['owner-type']});
      } catch (err) {
        console.log(err);
        this.$store.dispatch('updateLoadingError', this.query['owner-type'] === 'org' ? 'Organization Not Found' : 'User Not Found');
      }
      this.$store.dispatch('updateLoaded' , true);
    } else {
      this.$store.dispatch('updateLoadingError', 'Search a Github Organization ("yahoo") or User NOW !!');
    }
  }
}
</script>

<style>

#repos {
  width: 90%;
  margin: 40px auto;
}

#repos > div {
  margin-bottom: 25px;
  /* width: 360px; */
  width: 100%;
  /* height: 264px; */
  display: inline-block;
}

#repos-placeholder {
  margin: 40px auto;
  width: 90%;
  height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  font-size: 32px;
}

#repos-placeholder span {
  color: gray;
  text-align: center;
}

#loader-container {
  height: 50vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: none;
  position: relative;
  -webkit-box-shadow: none;
}

#loading-dimmer {
  border: none;
  background-color: white;
}

#loader {
  color: #393E46;
  opacity: 0.8;
}

#error-container {
  color: gray;
  opacity: 0.5;
  height: 400px;
  width: 100%;
  font-size: 32px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#error-container span {
  text-align: center;
  line-height: 1.5em;
}

@media screen and (min-width: 564px) {
  #error-container {
    padding: 40px;
  }

  #repos-placeholder {
    width: 80%;
  }
  
  #repos {
    width: 80%;
  }

  #repos > div {
    margin-bottom: 40px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  #repos > div {
    /* width: 360px; */
    width: 48%;
    /* height: 264px; */
  }

  #repos > div:nth-child(2n) {
    margin-left: 4%;
  }
}

@media screen and (min-width: 1024px) {
  #error-container {
    font-size: 40px;
  }

  #repos > div {
    /* width: 360px; */
    width: 31%;
    /* height: 264px; */
  }

  #repos > div:nth-child(3n-1), #repos > div:nth-child(3n) {
    margin-left: 3.5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SearchPage.vue